import styled from 'styled-components'

export const DivisionsBox = styled.div`
  display: flex;
  flex-flow: column;
  gap: 16px;
  margin-top: 16px;
`

export const CollapseBox = styled.div<{height?: number; $isExpanded: boolean}>`
  overflow: hidden;
  ${({$isExpanded, height}) =>
    $isExpanded ? `height: ${height}px;` : `height: 0px;`}
  transition: height 0.3s ease;
`
